import { inject, InjectionToken } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { calGuard } from '@cvx/cal-angular';
import { firstValueFrom, isObservable } from 'rxjs';
import { SecurityGroupService } from '../services/security-group.service';

export function hasMsalRedirectResponse(hash: string): boolean {
  const hashParameters = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  return ['code', 'error_description', 'error', 'state']
    .some((key) => Boolean(hashParameters.get(key)));
}

const isRedirectResponseAtStartup = typeof window !== 'undefined'
  && hasMsalRedirectResponse(window.location.hash);

export const MSAL_REDIRECT_RESPONSE_AT_STARTUP = new InjectionToken<boolean>(
  'MSAL_REDIRECT_RESPONSE_AT_STARTUP',
  {
    providedIn: 'root',
    factory: () => isRedirectResponseAtStartup
  }
);

export const securityGroupGuard: CanActivateFn = async (route, state) => {
  if (inject(MSAL_REDIRECT_RESPONSE_AT_STARTUP)) {
    return false;
  }

  const securityGroupService = inject(SecurityGroupService);
  const router = inject(Router);

  const authentication = calGuard(route, state);
  const authenticationResult = isObservable(authentication)
    ? await firstValueFrom(authentication)
    : await authentication;
  if (authenticationResult !== true) {
    return authenticationResult;
  }

  const isAuthorized = await securityGroupService.isUserInAllowedGroup();

  if (!isAuthorized) {
    return router.createUrlTree(['/unauthorized']);
  }

  return true;
};
